module.exports = __webpack_public_path__ + "media/errorbip.eb862210.wav";